// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"SS-z","inlineTitle":"TS-z","sponsoredAdsWrapper":"US-z","marketplaceRecosWrapper":"VS-z"};